export default {"src":"/_next/static/media/orientation-icon.2569b28c.svg","height":500,"width":500};